import { render, staticRenderFns } from "./OrderLocalisation.vue?vue&type=template&id=55e8569f&scoped=true"
import script from "./OrderLocalisation.vue?vue&type=script&lang=js"
export * from "./OrderLocalisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e8569f",
  null
  
)

export default component.exports